import {
    ICadastraEEditaVenda,
    IVendaFilter,
} from "../../../Interfaces/Geral/RegistraVenda/RegistraVendaInterface";
import {
    AtualizarStatusService,
    CadastrarVendaService,
    DeletarVendaService,
    EditarVendaService,
    GetVendaService,
    ListarVendaService,
} from "../../../Services/RegistraVenda/RegistraVendaServices";
import { ValidationErr } from "../../../Validations/ValidationError";
import { Controller } from "../../Controller";

export async function CadastrarVendaController(data: ICadastraEEditaVenda) {
    return Controller(CadastrarVendaService(data));
}

export async function ListarVendaController(
    page: number,
    quant: number,
    filter: IVendaFilter
) {
    return await ListarVendaService(page, quant, filter)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
}

export async function GetVendaController(idContaProduto: number) {
    return await GetVendaService(idContaProduto)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
}

export async function EditarVendaController(
    data: ICadastraEEditaVenda,
    idContaProduto: number
) {
    return Controller(EditarVendaService(data, idContaProduto));
}

export async function DeletarVendaController(idContaProduto: number) {
    return Controller(DeletarVendaService(idContaProduto));
}

export async function AtualizarStatusController(
    idContaProduto: number,
    FL_STATUS: boolean
) {
    return Controller(AtualizarStatusService(idContaProduto, FL_STATUS));
}
